const storeFilters = {
  categories: {
    placeholder: {
      en: 'category',
      ka: 'კატეგორიები'
    }
  },
  floors: {
    placeholder: {
      en: 'floors',
      ka: 'სართული'
    },
    data: [
      {
        name: {
          ka: '-2 სართული',
          en: '-2st floor'
        },
        value: '-2'
      },
      {
        name: {
          ka: '-1 სართული',
          en: '-1st floor'
        },
        value: '-1'
      },
      // {
      //   name: {
      //     ka: '0 სართული',
      //     en: '0 floor'
      //   },
      //   value: '0'
      // },
      {
        name: {
          ka: '1 სართული',
          en: '1st floor'
        },
        value: '1'
      },
      {
        name: {
          ka: '2 სართული',
          en: '2nd floor'
        },
        value: '2'
      },
      {
        name: {
          ka: '3 სართული',
          en: '3rd floor'
        },
        value: '3'
      }
    ]
  },
  sort: {
    placeholder: {
      en: 'default',
      ka: 'სტანდარტული'
    },
    data: [
      {
        name: {
          ka: '1 სართული',
          en: '1st floor'
        },
        value: '1st-floor'
      },
      {
        name: {
          ka: '2 სართული',
          en: '2nd floor'
        },
        value: '2nd-floor'
      },
      {
        name: {
          ka: '3 სართული',
          en: '3rd floor'
        },
        value: '3rd-floor'
      }
    ]
  }
}

export default storeFilters
